const BottomBar = {};

export default {
	BottomBar,
};
